import {
    computeBrushParametrics,
    computeBrushRadiusAtMousePosition,
    createParametrics,
    initStateFromFeatures,
    initStateFromStartingFeatures,
} from "../utils/lateralizedUtils"
import { computeLateralizedFeatures } from "../utils/layerUtils"


export let LateralizedStabiloMode = {}

const cursorFilePathes = {
    primary: "assets/resources/circle_cursor.png",
    green: "assets/resources/circle_cursor_vert-bon.png",
    yellow: "assets/resources/circle_cursor_jaune_remplacement-type.png",
    orange: "assets/resources/circle_cursor_orange_moyen.png",
    red: "assets/resources/circle_cursor_rouge-mauvais.png",
    blue: "assets/resources/circle_cursor_bleu_présence.png",
    purple: "assets/resources/circle_cursor_violet_autre-type.png",
}

// When the mode starts this function will be called.
// The value returned should be an object and will be passed to all other lifecycle functions
LateralizedStabiloMode.onSetup = function (opts) {
    var state = {}

    state.options = opts

    if (!state.options?.roadSegments?.features.length) {
        state.roadSegments = []
        return state
    }

    state.roadSegments = computeLateralizedFeatures(state.options.roadSegments, this.map)
    state.startingFeatures = state.options.startingFeatures

    this.map.on("zoom", () => {
        state.roadSegments = computeLateralizedFeatures(state.options.roadSegments, this.map)
        this._ctx.store.isDirty = true
        this._ctx.store.render()
    })
    this.map["dragPan"].disable()
    if (state.options?.brush?.name) {
        this.map.getCanvas().style.cursor = `url(${cursorFilePathes[state.options.brush.name.toLowerCase()]}) 32 32, pointer`
    } else {
        this.map.getCanvas().style.cursor = `url(${cursorFilePathes.primary}) 32 32, pointer`
    }

    const currentFeatures = state.options?.drawFeatures || []

    if (currentFeatures.length || state.options?.hasBeenUpdated) {
        state.parametricSegments = []
        state.featureIds = []

        initStateFromFeatures(state, currentFeatures)
    } else {
        const defaultParametrics = initStateFromStartingFeatures(state)
        createParametrics(this, state, defaultParametrics, true, state.options.existingFeatures)
    }

    return state
}

LateralizedStabiloMode.onDrag = function (state, e) {
    if (this.map && state.options.roadSegments) {
        const brushRadius = computeBrushRadiusAtMousePosition(this, e)

        const paintedParametrics = computeBrushParametrics(state, brushRadius, e, state.options?.brush?.properties)

        if (paintedParametrics.length) {
            const featuresUpdated = createParametrics(this, state, paintedParametrics, true, state.options.existingFeatures)

            if (featuresUpdated) {
                this.map.fire("draw.paint_updated")
            }
        }
    }
}

LateralizedStabiloMode.onMouseDown = function (state, e) {
    this.onDrag(state, e)
}

LateralizedStabiloMode.toDisplayFeatures = function (state, geojson, display) {
    const original = this.getFeature(geojson.properties.id)
    const featureCollection = {
        type: "FeatureCollection",
        features: [{
            ...geojson,
            properties: {
                ...original?.properties,
                ...geojson.properties,
            },
        }],
    }
    const lateralizedFeatureCollection = computeLateralizedFeatures(featureCollection, this.map)
    const feature = lateralizedFeatureCollection.features[0]
    display(feature)
}

LateralizedStabiloMode.onTrash = function (state) {
    const defaultParametrics = initStateFromStartingFeatures(state)
    createParametrics(this, state, defaultParametrics, true, state.options.existingFeatures)
}